import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  alertAnatomy.keys,
);

export const AlertTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      borderRadius: "md",
      fontSize: "sm",
      px: 3,
      py: 2,
      ".chakra-toast__inner > &.chakra-alert": {
        alignItems: "center",
        px: 3,
      },
    },
    title: {
      fontWeight: "semibold",
      lineHeight: "1.5",
      marginEnd: 0,
      "&:has(+.chakra-alert__desc)": {
        marginEnd: 2,
      },
    },
    description: {
      lineHeight: "1.5",
    },
    icon: {
      h: "auto",
      w: "auto",
      marginEnd: 2,
      "&:has(>.chakra-icon)": {
        h: 3.5,
        w: 3.5,
      },
    },
  },
  variants: {
    subtle: (props) => ({
      container: {
        bg: mode(`${props.colorScheme}.50`, undefined)(props),
        ".chakra-toast__inner > &.chakra-alert": {
          borderWidth: "1px",
          borderColor: mode("blackAlpha.50", "whiteAlpha.50")(props),
        },
      },
    }),
    neutral: (props) => ({
      container: {
        bg: "popoverBackground",
        borderWidth: "1px",
        borderColor: mode("blackAlpha.100", "whiteAlpha.300")(props),
      },
      icon: {
        color: mode(
          `${props.colorScheme}.500`,
          `${props.colorScheme}.400`,
        )(props),
      },
    }),
  },
});
